export const DRUPAL_ENDPOINT = import.meta.env.VITE_DRUPAL_ENDPOINT;
export const DRUPAL_ENDPOINT_TOKEN = import.meta.env.VITE_DRUPAL_ENDPOINT_TOKEN;
